import { render } from "./SvgIcons.vue?vue&type=template&id=54eee3ec&scoped=true"
import script from "./SvgIcons.vue?vue&type=script&lang=js"
export * from "./SvgIcons.vue?vue&type=script&lang=js"

import "./SvgIcons.vue?vue&type=style&index=0&id=54eee3ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54eee3ec"]])

export default __exports__